import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../../BusinessInfo/css/BusinessInfo.css';
import Text from '../../../common/Text.js';
import design1_1 from '../img/VR1_1.jpg';
import design1_2 from '../img/VR1-2.jpg';
import design1_3 from '../img/VR1-3.jpg';
import design1_4 from '../img/VR1-4.jpg';
import design1_5 from '../img/VR1-5.jpg';
import design2_1 from '../img/VR2-1.JPG';
import design2_2 from '../img/VR2-2.JPG';
import design2_3 from '../img/VR2-3.JPG';
import design3_1 from '../img/VR3-1.png';
import design3_2 from '../img/VR3-2.JPG';
import design3_3 from '../img/VR3-3.png';

// 사업소개 (리뉴얼) - 설계
function VR() {
    

    useEffect(() => {


        const options = {
            // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
            root: null,
            // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
            threshold: 0.5
    
        };
  
  
        // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv1');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".Cont1_1")

        ims.forEach(img =>
            observer.observe(img)
        );
    

        // Intersection Observer 인스턴스
        const observer2 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv2');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims2 = document.querySelectorAll(".Cont1_2")

        ims2.forEach(img =>
            observer2.observe(img)
        );
    


        // Intersection Observer 인스턴스
        const observer3 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv3');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims3 = document.querySelectorAll(".Cont1_3")

        ims3.forEach(img =>
            observer3.observe(img)
        );

        

        // Intersection Observer 인스턴스
        const observer4 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv4');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims4 = document.querySelectorAll(".box1_img")

        ims4.forEach(img =>
            observer4.observe(img)
        );

        
        // Intersection Observer 인스턴스
        const observer5 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv5');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims5 = document.querySelectorAll(".box2_img")

        ims5.forEach(img =>
            observer5.observe(img)
        );
    

        
        // Intersection Observer 인스턴스
        const observer6 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv6');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims6 = document.querySelectorAll(".box3_img")

        ims6.forEach(img =>
            observer6.observe(img)
        );
    
    
    
    
            
    
          }, [])
    
    


    return (
        <div class = 'groupa' style={{display:'flex', justifyContent : 'center'}}>

            <div class="page"> 

 
                <div class="Cont_1" > 
                <div class="Cont1_1" > 
                    <Text  variant="px32w700B"  className='MidTitle'>조선해양 산업의 미래를 이끄는 스마트 VR 교육 기술</Text>
                    </div>
            
            {/* <div class="Cont1_2" > 
                <Text  variant="px28w400"  className='SmallTitle'>IT 솔루션으로 디지털 전환과 스마트화를 선도합니다.</Text> 
                </div> */}

<div class="Cont1_3" > 
    <Text variant="px28w400" className='Contents' style={{marginTop : '0px'}}> 
    VR 기술을 활용하여 조선∙해양 산업에 특화된 직무교육 솔루션을 제공합니다.
    </Text>
    <Text variant="px20w400" className='Contents' style={{marginTop : '10px'}}> 
   실제 작업환경을 가상공간에 구현하여 안전한 반복 훈련이 가능하며, 실시간 데이터 분석을 통해 교육 효과와 작업 숙련도를 향상시키는 스마트 교육 시스템을 제공합니다.
    </Text>
                </div>
                </div>

                <div class="boxFrame">

                    <Text  variant="px32w700B"  className='MidTitle'>대표 프로젝트</Text>

                    <div class="Contents_GRP">


                        <div class="box1s_VR">
                                <div class="box1_img_VR" >

                                    <div class='proj_box_vr1'>
                                        <div class="box1_VR">
                                            <img class="proj_img_VR1"  src={design1_1} />
                                            <img class="proj_img_VR1"  src={design1_2} />
                                        </div>

                                        <div class="box1_VR2">
                                            <img class="proj_img_VR2"  src={design1_3} />
                                            <img class="proj_img_VR2"  src={design1_4} />
                                            <img class="proj_img_VR2"  src={design1_5} />

                                        </div>
      
                                    </div>
                            </div>
                                                         
                    <Text variant="px24w600_B" className='proj_nm_VR1'>자율 운항 시스템</Text>
                            <Text variant="px18w400_B" className='proj_nm_Cnts_VR'>실제 조선소 작업환경과 동일한 VR 공간에서 안전하고 반복적인 훈련을 제공합니다. 도장 및 취부 작업을 비롯한 다양한 작업 자세와 작업환경을 구현하여 교육생의 실무 적응력과 작업 숙련도를 높입니다.</Text>   
                        </div>



                    <div className="box2s_VR">
                                <div class="box2_img_VR" >

                                    <div class='proj_box_vr1'>
                                        <div class="box2_VR">
                                            <img class="proj_img_VR1_1"  src={design2_1} />
                                            <img class="proj_img_VR1_1"  src={design2_2} />
                                            <img class="proj_img_VR1_2"  src={design2_3} />
                                        </div>
                                    </div>
                            </div>
                            <Text variant="px24w600_B" className='proj_nm_VR1'>실시간 교육 피드백</Text>
                            <Text variant="px18w400_B" className='proj_nm_Cnts_VR'>훈련 중 작업 거리, 속도, 도막 두께(DFT) 등 주요 데이터를 실시간으로 분석하여 즉각적인 피드백을 제공합니다. 교육생은 자신의 작업 결과를 바로 확인하고 반복 학습을 통해 작업 품질을 향상시킬 수 있습니다.</Text>   
                                
                    </div>



                    <div className="box3s_VR">
                                <div class="box2_img_VR" >

                                    <div class='proj_box_vr1'>
                                        <div class="box2_VR">
                                            <img class="proj_img_VR1_1"  src={design3_1} />
                                            <img class="proj_img_VR1_2"  src={design3_2} />
                                            <img class="proj_img_VR1_1"  src={design3_3} />
                                        </div>
                                    </div>
                            </div>
                            <Text variant="px24w600_B" className='proj_nm_VR1'>교육 결과 분석 및 평가</Text>
                            <Text variant="px18w400_B" className='proj_nm_Cnts_VR'>훈련 결과를 자동 분석하여 점수, 도막 두께, 분사 경로, 도료 사용량, 작업시간 등 객관적인 데이터를 제공합니다. 또한 정부인정 기업자격 기준을 적용한 평가 시스템을 통해 체계적인 교육 관리와 성과 평가를 지원합니다.</Text>   
                                
                    </div>


                    <div className="box4s_VR" style={{marginTop : '70px'}}>
                            <Text variant="px24w600_B" className='proj_nm_VR1'>구축 실적</Text>
                            <Text variant="px18w400_B" className='proj_nm_Cnts_VR'>국내 조선소 및 공공기관 교육장에 VR 교육 시스템을 구축하여 운영하고 있으며, 2026년 7월 기준 총 16대의 시스템을 납품하였습니다.</Text>   
                                
                    </div>
                        {/* <div class="box3">

                <div class="box3_img" >
                            <img class="proj_img3"  src={design3} ></img>
                            </div>
                            <div class="box3_child">
                                <Text variant="px24w600_B" className='proj_nm'>자율 운항 시스템</Text>
                                <Text variant="px18w400_B" className='proj_nm_Cnts'>인공지능 등 첨단 기술을 운항 시스템에 접목한 완전 자율운항 시스템입니다.</Text>
                            </div>

                        </div>  */}
                    </div>
                </div>

            </div >

        </div>
     );
 }
 
 export default VR;